import { memo } from 'react';

import { alpha, Box, Typography } from '@mui/material';

interface MapTitleProps {
  title: string;
}

const MapTitle = ({ title }: MapTitleProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: (theme) => theme.spacing(3),
        left: '50%',
        transform: 'translateX(-50%)',
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.7),
        borderRadius: 0.5,
        py: 1.5,
        px: 2,
        width: '90%',
      }}
    >
      <Typography variant='body2' color='textTertiary'>
        {title}
      </Typography>
    </Box>
  );
};

export default memo(MapTitle);
